import Vue from 'vue';
import { assign } from 'lodash';
import * as api from 'api/api-instance';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
  data: {},
  meta: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  InstanceDetails: state => state,
};

const actions = {
  GetInstanceDetails({ commit }) {
    commit(types.FETCH_INSTANCE_DETAILS_START);
    api.getDetails(
      (response) => {
        commit(types.RECEIVE_INSTANCE_DETAILS, { response });
      },
      (error, status, saveError) => {
        if (status === 404) {
          commit(types.FETCH_INSTANCE_DETAILS_NOT_FOUND, { saveError });
        } else {
          commit(types.FETCH_INSTANCE_DETAILS_ERROR, { saveError });
        }
      },
    );
  },
  SaveInstanceDetails({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const payload = params.payload;
      commit(types.SAVE_INSTANCE_DETAILS_START);
      console.log('save data', params);
      api.updateDetails(
        payload,
        (response) => {
          console.log('save');
          commit(types.SAVE_INSTANCE_DETAILS_SUCCESSFUL, { response });
          dispatch('UpdateInstanceInfo', { response });
          resolve(true);
        },
        (error, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.SAVE_INSTANCE_DETAILS_ERROR, { saveError });
          reject(error);
        },
      );
    });
  },
  SaveInstanceLogo({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const file = params.file;
      commit(types.SAVE_INSTANCE_LOGO_START);
      console.log('save data SaveInstanceLogo', params);
      api.setInstanceLogo(
        file,
        (response) => {
          console.log('save SaveInstanceLogo');
          commit(types.SAVE_INSTANCE_LOGO_DONE, { response });
          dispatch('UpdateInstanceInfo', { response });
          resolve(true);
        },
        (error, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.SAVE_INSTANCE_LOGO_ERROR, { saveError });
          reject(error);
        },
      );
    });
  },
  RemoveInstanceLogo({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      commit(types.REMOVE_INSTANCE_LOGO_START);
      api.removeInstanceLogo(
        () => {
          commit(types.REMOVE_INSTANCE_LOGO_DONE);
          dispatch('UpdateInstanceInfo', { removeLogo: true });
          resolve(true);
        },
        (error, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.REMOVE_INSTANCE_LOGO_ERROR, { saveError });
          reject(error);
        },
      );
    });
  },
  ChangeInstanceOwnerEmail({ commit }, params) {
    const email = params.email;
    const emailVerified = params.email_verified;
    commit(types.CHANGE_INSTANCE_OWNER_EMAIL, { email, emailVerified });
  },
  ClearInstanceDetails({ commit }) {
    commit(types.CLEAR_INSTANCE_DETAILS_STORE);
  },
};

const mutations = {
  [types.FETCH_INSTANCE_DETAILS_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.FETCH_INSTANCE_DETAILS_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.FETCH_INSTANCE_DETAILS_NOT_FOUND](state) {
    assign(state, neutralState, { notFound: true });
  },
  [types.RECEIVE_INSTANCE_DETAILS](state, { response }) {
    assign(state, neutralState, { ready: true, data: response.data, meta: response.meta });
  },
  [types.CLEAR_INSTANCE_DETAILS_STORE](state) {
    assign(state, initState);
  },
  [types.SAVE_INSTANCE_DETAILS_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.SAVE_INSTANCE_DETAILS_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.SAVE_INSTANCE_DETAILS_SUCCESSFUL](state, { response }) {
    assign(state, neutralState, { saved: true, data: response.data, meta: response.meta });
  },
  [types.SAVE_INSTANCE_LOGO_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.SAVE_INSTANCE_LOGO_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.SAVE_INSTANCE_LOGO_DONE](state, { response }) {
    assign(state, neutralState);
    Vue.set(state.data, 'Logo', response.data);
  },
  [types.REMOVE_INSTANCE_LOGO_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.REMOVE_INSTANCE_LOGO_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.REMOVE_INSTANCE_LOGO_DONE](state) {
    assign(state, neutralState);
    Vue.set(state.data, 'Logo', null);
  },
  [types.CHANGE_INSTANCE_OWNER_EMAIL](state, { email, emailVerified }) {
    assign(state, neutralState);
    Vue.set(state.data, 'email', email);
    Vue.set(state.data, 'email_verified', emailVerified);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/instance/entities/instance-details.js